// Given a PatternEventValue, generate a set of data for graphing it.
export function generateGraphDataFromPattern(_a) {
    var patternEventValue = _a.patternEventValue, width = _a.width, height = _a.height, padding = _a.padding, library = _a.library;
    // Event widths fit in the space; event heights match the widths.
    var noteWidth = Math.ceil((width - 2 * padding) / 16);
    var noteHeight = noteWidth;
    // Blocks' locations will be for their upper-left corners, so ensure
    // that the space we are filling counts for the full size of the blocks.
    var useWidth = width - 2 * padding - noteWidth;
    var useHeight = height - 2 * padding - noteHeight;
    var currentFolder = library.getFolderForPath(patternEventValue.kit);
    if (!currentFolder) {
        return [];
    }
    var numSounds = currentFolder.sounds.length;
    return patternEventValue.events.map(function (event) {
        var soundIndex = currentFolder.sounds.findIndex(function (sound) { return sound.src === event.src; });
        return {
            x: 1 + ((event.tick - 1) * useWidth) / (16 - 1) + padding,
            y: 1 + padding + (soundIndex * useHeight) / (numSounds - 1),
            width: noteWidth,
            height: noteHeight,
        };
    });
}
